import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Navigate, Redirect, Route, Routes, Switch} from "react-router-dom";
import "./sass/main.scss";
import Home from "./home/Home";
import Login from "./login/Login";
import Dashboard from "./dashboard/Dashboard";
import Inspection from "./inspection/Inspection";
import SmartSelect from "./smartselect/SmartSelect";
import SmartSelectCreateOption from "./smartselect/smartselect-createoption/SmartSelectCreateOption";
import AppSelection from "./appselection/AppSelection";
import ProblematicWasteStreams from "./referenceapp/problematicwastestreams/ProblematicWasteStreams";
import AppStorage from "./util/AppStorage";
import Popup from "./components/popup/Popup";
import Api from "./util/Api";
import LoadingIndicator from "./components/loadingindicator/LoadingIndicator";
import AuthRoute from "./login/AuthRoute";
import Detail, {
    AboutDetail,
    DatabasesDetail,
    ProblematicWasteStreamDetail,
    ReferencesDetail
} from "./referenceapp/detail/Detail";
import About from "./referenceapp/about/About";
import References from "./referenceapp/references/References";
import Databases from "./referenceapp/database/Databases";
import CheckTheControls from "./referenceapp/checkthecontrols/CheckTheControls";

function App() {
    const [isAppUserRegistered, setIsAppUserRegistered] = useState(AppStorage.isAppGUIDRegistered());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if(!isAppUserRegistered) {
            createAppUser();
        }
    }, []);

    if(!isAppUserRegistered) {
        return <LoadingIndicator isLoading={isLoading} indicatorColor={"dark"} showBackgroundOverlay={false}
                              isFullscreen={true}/>
    }

    return (
        <Router>
            <link rel="stylesheet"
                  href="https://fonts.googleapis.com/css?family=Roboto:regular,bold,italic|PT+Sans+Narrow:regular,bold">
            </link>
            <div className="App">
                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/appselection" element={<AppSelection/>}/>
                    <Route path="/referenceapp/problematicwastestreams" element={<ProblematicWasteStreams/>}/>
                    <Route path="/referenceapp/problematicwastestreams/:id" element={<ProblematicWasteStreamDetail/>}/>
                    <Route path="/referenceapp/checkthecontrols" element={<CheckTheControls/>}/>
                    <Route path="/referenceapp/references" element={<References/>}/>
                    <Route path="/referenceapp/references/:id" element={<References/>}/>
                    <Route path="/referenceapp/references/:id/detail/:detailId" element={<ReferencesDetail/>}/>
                    <Route path="/referenceapp/databases" element={<Databases/>}/>
                    <Route path="/referenceapp/databases/:id" element={<Databases/>}/>
                    <Route path="/referenceapp/databases/:id/detail/:detailId" element={<DatabasesDetail/>}/>
                    <Route path="/referenceapp/about" element={<About/>}/>
                    <Route path="/referenceapp/about/:id" element={<AboutDetail/>}/>
                    <Route path="/referenceapp/detail/:id" element={<Detail/>}/>
                    <Route path="/referenceapp" element={<Navigate to="/referenceapp/problematicwastestreams" replace/>}/>
                    <Route path="/dashboard" element={<AuthRoute element={<Dashboard/>}/>}/>
                    <Route path="/inspection" element={<AuthRoute element={<Inspection/>}/>}/>
                    <Route path="/inspection/smartselect/:id/create" element={<AuthRoute element={<SmartSelectCreateOption/>}/>}/>
                    <Route path="/inspection/smartselect/:id" element={<AuthRoute element={<SmartSelect/>}/>}/>
                    <Route path="/" element={<Home/>}/>
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
            </div>
        </Router>
    );

    function createAppUser() {
        let newAppGUID = AppStorage.generateAppGUID();

        function validator(response) {
        }

        function onSuccess(response) {
            setIsLoading(false);
            AppStorage.setRegisteredAppGUID(newAppGUID);
            setIsAppUserRegistered(true);
        }

        function onFailure(error) {
            setIsLoading(false);
            Popup.showDefaultRequestError(function () {
                createAppUser()
            })
        }

        const config = {
            data: {
                "firmware": "N/A",
                "phoneType": "Web",
                "appGUID": newAppGUID,
                "appVersionCode": process.env.REACT_APP_APP_VERSION,
                "appVersionName": process.env.REACT_APP_APP_VERSION_NAME
            }
        };

        setIsLoading(true);
        Api.post('/appuser', validator, onSuccess, onFailure, config);
    }
}

export default App;
